import axios from "axios";
import { apiUrl, PORT } from "../environment";
import axiosClient from "./axiosClient";
import { toast } from "react-toastify";

const login = async (data, dispatch) => {
    const url = `${apiUrl}${PORT}/auth-service/login`;
    try {
        const response = await axios.post(url, data);
        if (response.data.status) {
            localStorage.setItem("user", JSON.stringify(response.data));
            return response;
        } else {
            return response;
        }
    } catch (e) {
        if (e.response) {

        }
        return null;
    }
};

const logout = () => {
    localStorage.clear();
};
const forgotPassword = async (email) => {
    try {
        const response = await axios.post(`${apiUrl}${PORT}/auth-service/forget-password`, email);
        return response.data;
    } catch (e) {
        return e;
    }
};

const resetPassword = (email) => {
    return axios
        .post(`${apiUrl}${PORT}/reset/password`, email)
        .then((response) => {
            return response.data;
        });
};

const verifyToken = (email, token) => {
    return axios
        .post(`${apiUrl}${PORT}/verify/token`, { email, token })
        .then((response) => {
            return response.data;
        });
};

/**
* @description registration in db.
* @param {*} data
* @param {*} callback
*/

export const registration = (data, callback, dispatch) => {
    try {
        return axios
            .post(`${apiUrl}${PORT}/signup`, data)
            .then((response) => {

                callback(response.data);
            })
            .catch((error) => {
                callback(false);
            });
    } catch (err) {
    }
};

/**
 * @description contactUs in db.
 * @param {*} data
 * @param {*} callback
 */
export const contact_us = (data, callback, dispatch) => {
    try {
        //   dispatch(loadingAction(true));
        return axios
            .post(`${apiUrl}${PORT}/contact-us`, data)
            .then((response) => {
                //   dispatch(loadingAction(false));
                callback(response.data);
            })
            .catch((error) => {
                //   dispatch(loadingAction(false));
                callback(false);
            });
    } catch (err) {
    }
};


// connect with us service 

export const connectWithUs = async (data) => {
    try {
        const response = await axiosClient.post(`/user-service/connect-with-us`, data);
        if (response?.status === "SUCCESS") {
            toast.success(response.message || "Connect with us request sent successfully");
            return response;
        } else {
            toast.error(response.message);
        }
    } catch (err) {
        toast.error("An error occurred while creating the survey");
    }
};

const AuthService = {
    login,
    logout,
    forgotPassword,
    verifyToken,
    resetPassword
};

export default AuthService;
